import { Component, NgModule, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-translation-input',
  templateUrl: './translation-input.component.html',
  styleUrls: ['./translation-input.component.scss']
})
export class TranslationInputComponent implements OnInit {
  lang: string;

  constructor(private translate: TranslocoService) {
  }

  ngOnInit() {
    this.lang = localStorage.getItem('lang') || 'es';
    this.translate.setActiveLang(this.lang);
  }


  onLanguageChange(lang: string) {
    if (this.lang === lang) {
      return;
    }
    this.translate.setActiveLang(this.lang = lang);
    localStorage.setItem('lang', lang);

    const usersnap = window['Usersnap'];
    if (usersnap) {
      // usersnap.getConfig().locale = this.lang;
      // usersnap.hideButton();
      // usersnap.showButton();
    }
    // TODO: change locales dynamically to update dates
    // https://github.com/angular/angular/issues/15039#issuecomment-496133812
  }
}

@NgModule({
  declarations: [TranslationInputComponent],
  exports: [TranslationInputComponent]
})
export class TranslationInputComponentModule {}
